import React, { useState } from 'react';
import Form from 'js/components/common/Form';
import { Button } from 'js/components/common/Button';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import * as hooks from './hooks/useOnSubmit';
import * as Types from './types';
import { SwissInput } from '../../common/Fields/SwissInput/SwissInput';

import { useTranslations } from 'js/hooks/i18n';
import style from './PromoCode.scss';

export const PromoCodeBare: React.FC = () => {
    const t = useTranslations();
    const onSubmit = hooks.useOnSubmit();
    const translate = useComponentTranslations();
    const [active, setActive] = useState(false);

    const onFocus = (values: Types.IPromoCodeFormValues) => {
        setActive(true);
        values.errorValid = false;
    };

    const onBlur = (values: Types.IPromoCodeFormValues) => {
        setActive(false);
        values.errorValid = false;
    };

    return (
        <div className={`${style.container} cms-promo-code`}>
            <Form<Types.IPromoCodeFormValues>
                onSubmit={onSubmit}
                render={({ submitError, handleSubmit, values }) => (
                    <form
                        className={`${style.form} ${active ? style.active : style.inactive} ${values?.errorValid ? style.errorField : style.noError} ${values?.promoCode ? style.valueExist : style.noValue}`}
                        onSubmit={handleSubmit}
                    >
                        {submitError && <ErrorMessage error={submitError} className={style.error} animate={false}/>}
                        <SwissInput
                            id="promoCode"
                            name="promoCode"
                            className={style.control}
                            labelText='playtech.mobile.system.promocode.placeholder'
                            placeholder={translate('playtech.mobile.system.promocode.input.placeholder')}
                            isLabelExist={true}
                            errorMessage={t('playtech.mobile.system.tooltip.required')}
                            noValidate={true}
                            errorAppeared={values?.errorValid}
                            notEmpty={values?.promoCode}
                            onClick={() => onFocus(values)}
                            onBlur={() => onBlur(values)}
                        />

                        <Button
                            type="submit"
                            className={style.submit}
                        >
                            {translate('submit')}
                        </Button>
                    </form>
                )}
            />
        </div>
    );
};

export const PromoCode = withComponent({
    isForLoggedIn: true,
    tkPrefix: 'playtech.mobile.system.promocode.'
})(PromoCodeBare);

// <hub2-promocode></hub2-promocode>
componentService.registerWebContentComponents({ PromoCode });
